import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminReservation from "./AdminReservation";
import SuiviPlanning from "./SuiviPlanning";
import AdminLocal from "./AdminLocal";

const adminSections = [
  { id: "reservation", label: "Réservation" },
  { id: "planning", label: "Suivi planning" },
  { id: "local", label: "Local et Activité" },
];

function Console() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedSection, setSelectedSection] = useState(() => {
    const pref = location.state?.adminReservation;
    return pref?.section || pref ? "reservation" : adminSections[0].id;
  });
  const [adminPrefill, setAdminPrefill] = useState(() => {
    const pref = location.state?.adminReservation;
    if (pref) {
      const { section, ...rest } = pref;
      return rest;
    }
    return null;
  });

  useEffect(() => {
    const state = location.state;
    if (state && state.adminReservation) {
      const { section, ...rest } = state.adminReservation;
      setSelectedSection(section || "reservation");
      setAdminPrefill(rest);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const activeSection = useMemo(
    () =>
      adminSections.find((section) => section.id === selectedSection) ||
      adminSections[0],
    [selectedSection]
  );

  const renderButton = (section) => {
    const isActive = section.id === activeSection.id;
    const baseClasses =
      "px-5 py-2.5 rounded-xl text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-orange-500";
    const activeClasses =
      "bg-orange-600 text-white shadow-lg shadow-orange-200 hover:bg-orange-700";
    const inactiveClasses =
      "border-2 border-orange-500 text-orange-600 bg-white hover:bg-orange-50";

    return (
      <button
        key={section.id}
        type="button"
        aria-pressed={isActive}
        onClick={() => setSelectedSection(section.id)}
        className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
      >
        {section.label}
      </button>
    );
  };

  return (
    <div className="flex flex-col w-full mx-auto px-4 sm:px-6 lg:px-8 min-h-screen mb-20">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <h1 className="text-orange-600 text-3xl font-bold mt-6">
          Page Administration
        </h1>
        <div className="flex flex-wrap gap-3">{adminSections.map(renderButton)}</div>
      </div>

      <div className="mt-6">
        {activeSection.id === "reservation" && (
          <AdminReservation
            prefillSelection={adminPrefill}
            onPrefillConsumed={() => setAdminPrefill(null)}
          />
        )}
        {activeSection.id === "planning" && <SuiviPlanning />}
        {activeSection.id === "local" && <AdminLocal />}
      </div>
    </div>
  );
}

export default Console;
